import React, { memo } from 'react';
import { MarkerPart } from './Marker.styled';

interface IMarkerProps {
  query: string;
  children: React.ReactNode;
}

export const Marker: React.FC<IMarkerProps> = memo(({ query = '', children }) => {
  if (React.Children.count(children) > 1 || typeof children !== 'string') {
    return <>{children}</>;
  }

  if (query === '') return <>{children}</>;

  // Split text on highlight term, include term itself into parts, ignore case
  const parts = String(children).split(new RegExp(`(${query})`, 'gi'));

  return (
    <>
      {parts.map((part, i) => (
        <MarkerPart key={part + i} isMarked={part?.toLowerCase() === query?.toLowerCase()}>
          {part}
        </MarkerPart>
      ))}
    </>
  );
});
